import React, { useContext } from "react";
import {
  Caption,
  Card,
  Collapsible,
  ColorPicker,
  Layout,
  Stack,
  TextField,
  TextStyle,
  TextContainer,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Content = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, CONTENT, DEFAULT_CONTENT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.contentColor.title")}
        description={cms("section.contentColor.description")}
      >
        <Card
          title={[
            cms("section.contentColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
        >
          <Card.Section>
            <TextContainer>{cms("section.contentColor.subDescription")}</TextContainer>

            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.contentColor.label.hexCode")}
                  value={hex.contentHex}
                  onChange={(value) => handleChange(CONTENT, value, HEX)}
                  labelAction={
                    hex.contentHex !== DEFAULT_CONTENT_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(CONTENT, DEFAULT_CONTENT_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.content}
                />
                <br />
                <TextStyle>
                  <div
                    style={{
                      width: "120px",
                      height: "50px",
                      color: hex.contentHex,
                      textAlign: "center",
                      paddingTop: "13px",
                    }}
                  >
                    {cms("section.contentColor.label.sampleHeader")}
                  </div>
                </TextStyle>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker onChange={(value) => handleChange(CONTENT, value, COLOR)} color={color.contentColor} />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(Content);
